var map = {
	"./_bak_logo.svg": "XOQm",
	"./collect.svg": "Tw70",
	"./compose-price.svg": "WS76",
	"./coupon-selected.svg": "bnEy",
	"./coupon-unselected.svg": "QOIH",
	"./coupon-used.svg": "lACK",
	"./coupon-useless.svg": "cRob",
	"./del.svg": "bpt5",
	"./detail-+++.svg": "nemq",
	"./detail-===.svg": "st5J",
	"./detail-checked.svg": "/1iI",
	"./detail-deals.svg": "2Mha",
	"./detail-done.svg": "4R6P",
	"./detail-express.svg": "H7KQ",
	"./detail-getout.svg": "t+du",
	"./detail-paySuccess.svg": "480T",
	"./detail-submit.svg": "+Q8X",
	"./eva-success.svg": "1YjN",
	"./exchange.svg": "zi5X",
	"./logo.svg": "9CEG",
	"./nav-addres.svg": "5pss",
	"./nav-aftersale.svg": "71xn",
	"./nav-coupon.svg": "LJpn",
	"./net-error.svg": "1xX4",
	"./no-result.svg": "T1xG",
	"./notice-public.svg": "vh9m",
	"./order-result-pa.svg": "4XLr",
	"./order-result-success.svg": "2ECY",
	"./pay-checked.svg": "YHEL",
	"./pay-coupon-default.svg": "+m9f",
	"./pay-coupon-selected.svg": "YTQv",
	"./pay-unchecked.svg": "61Kq",
	"./search.svg": "0R99",
	"./shop-service.svg": "Se3A",
	"./success.svg": "cQmE",
	"./unCollect.svg": "CCtv",
	"./user-coupon-nodata.svg": "jFdp",
	"./user-coupon.svg": "3Pwz",
	"./user-dingwei-nodata.svg": "5hyo",
	"./user-dingwei.svg": "7qzQ",
	"./user-favorite-nodata.svg": "5l+o",
	"./user-favorite.svg": "y1Yl",
	"./user-foot-nodata.svg": "EIgn",
	"./user-foot.svg": "9TFX",
	"./user-info.svg": "vLOi",
	"./user-notice-icon.svg": "cCB9",
	"./user-notice-nodata.svg": "lTCx",
	"./user-notice.svg": "2CEC",
	"./user-order-nodata.svg": "3hzl",
	"./user-order.svg": "JoJg",
	"./user-pingjia.svg": "RaeD",
	"./user-resetphone.svg": "VOxo",
	"./user-shouhou.svg": "9ywm",
	"./user-wenda-nodata.svg": "lm/f",
	"./user-wenda.svg": "wCi3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2tc1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg nonrecursive \.svg$
// module id = 2tc1
// module chunks = 64